import {createKeyframes, view, animate, AnimatePresence} from '@sail/engine';
import {dotComColors} from '../../theme';
import {ChatBubbleDotCom} from './ChatBubbleDotCom';

const typingBubble1 = createKeyframes({
  0: {
    transform: 'translate3d(0, 0, 0)',
  },
  12.5: {
    transform: 'translate3d(0, -4px, 0)',
  },
  25: {
    transform: 'translate3d(0, 0, 0)',
  },
});

const typingBubble2 = createKeyframes({
  0: {
    transform: 'translate3d(0, 0, 0)',
  },
  12.5: {
    transform: 'translate3d(0, 0, 0)',
  },
  25: {
    transform: 'translate3d(0, -4px, 0)',
  },
  37.5: {
    transform: 'translate3d(0, 0, 0)',
  },
});

const typingBubble3 = createKeyframes({
  0: {
    transform: 'translate3d(0, 0, 0)',
  },
  25: {
    transform: 'translate3d(0, 0, 0)',
  },
  37.5: {
    transform: 'translate3d(0, -4px, 0)',
  },
  50: {
    transform: 'translate3d(0, 0, 0)',
  },
});

type Props = {
  animateIn?: boolean;
};

export const TypingRowDotCom = ({animateIn = true}: Props) => {
  return (
    <AnimatePresence>
      <view.div
        data-testid="typing-row"
        css={{
          width: 'fit-content',
          opacity: 1,
          scale: 1,
          transformOrigin: 'bottom left',
        }}
        uses={[
          animate.in({
            duration: 250,
            opacity: 0,
            transform: 'scale(0.6)',
            easing: 'ease-out',
            disabled: !animateIn,
          }),
        ]}
      >
        <ChatBubbleDotCom background="neutral100" animation="disabled">
          <view.span
            css={{
              // constraining the dimensions to 16px
              // the viewbox within the svg will ensure the
              // dimensions are accurate within that constraint (16x4)
              maxWidth: '16px',
              // the 100% height will ensure this span container
              // fills the default height of the ChatBubble,
              // allowing us to center the svc vertically
              height: '100%',
              // center the svg within the span
              marginX: 'xsmall',
              marginY: 'small',
              stack: 'y',
              align: 'center',
            }}
          >
            <AnimatePresence>
              <view.svg
                // scale the svg to fill the span container
                width="100%"
                height="100%"
                // constrain the svg to 16x4 relative to the scaled dimensions
                viewBox="0 0 16 4"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                css={{overflow: 'visible'}}
              >
                <view.circle
                  data-testid="typing-row-circle"
                  cx={2}
                  cy={2}
                  r={2}
                  fill={dotComColors.brand600}
                  opacity={0.4}
                  css={{
                    animation: `${typingBubble1} 1s cubic-bezier(0, 0.7, 1, 0.3) infinite`,
                  }}
                />
                <view.circle
                  data-testid="typing-row-circle"
                  cx={8}
                  cy={2}
                  r={2}
                  fill={dotComColors.brand600}
                  opacity={0.4}
                  css={{
                    animation: `${typingBubble2} 1s cubic-bezier(0, 0.7, 1, 0.3) infinite`,
                  }}
                />
                <view.circle
                  data-testid="typing-row-circle"
                  cx={14}
                  cy={2}
                  r={2}
                  fill={dotComColors.brand600}
                  opacity={0.4}
                  css={{
                    animation: `${typingBubble3} 1s cubic-bezier(0, 0.7, 1, 0.3) infinite`,
                  }}
                />
              </view.svg>
            </AnimatePresence>
          </view.span>
        </ChatBubbleDotCom>
      </view.div>
    </AnimatePresence>
  );
};
